import { useContext } from 'react'

import { TrackingEventsContext } from 'contexts/trackingEventsProvider'

export const useTriggerEvent = () =>
  useContext(TrackingEventsContext).triggerEvent
